var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutCoreIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.25H27.5V17.75H26V14.75H23V13.25ZM12.5 13.25H17V14.75H14V17.75H12.5V13.25ZM26 25.25V22.25H27.5V26.75H23V25.25H26ZM14 25.25H17V26.75H12.5V22.25H14V25.25Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutCoreIcon3);
export default __webpack_public_path__ + "static/media/about_core_icon3.1f3006b278fd3ff932a10ddd11a10ce8.svg";
export { ForwardRef as ReactComponent };